export default __webpack_public_path__ + "static/media/logoCenterAligned.aa2c18ad.png";